import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Hero from "@/components/sections/Hero";
import { PRICING_ITEMLIST_SCHEMA, SITE } from "@/lib/seo";

// Lazy below-the-fold sections — reduce el bundle inicial de la home en ~40-60 KiB.
// vite-react-ssg sigue pre-renderizándolas en build time para SEO.
const ServiceSelector = lazy(() => import("@/components/sections/ServiceSelector"));
const PricingSection = lazy(() => import("@/components/sections/PricingSection"));
const TrustpilotBar = lazy(() => import("@/components/sections/TrustpilotBar"));
const TeamSection = lazy(() => import("@/components/sections/TeamSection"));
const ClientsSection = lazy(() => import("@/components/sections/ClientsSection"));
const ReviewsSection = lazy(() => import("@/components/sections/ReviewsSection"));
const ContactSection = lazy(() => import("@/components/sections/ContactSection"));
const Footer = lazy(() => import("@/components/layout/Footer"));

const HOME_TITLE = "Agencia de Marketing Digital para PYMEs | Vibra Marketing";
const HOME_DESCRIPTION =
  "Agencia de marketing digital en Madrid para PYMEs. Planes desde 199€/mes IVA incluido, sin permanencia. Ads, SEO, redes, email y web.";

const Index = () => {
  return (
    <div className="min-h-screen bg-background scroll-smooth">
      <Helmet>
        <html lang="es" />
        <title>{HOME_TITLE}</title>
        <meta name="description" content={HOME_DESCRIPTION} />
        <meta
          name="keywords"
          content="agencia marketing digital, agencia marketing pymes, meta ads, google ads, seo, redes sociales, email marketing, marketing madrid, plan marketing 199"
        />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
        <link rel="canonical" href={`${SITE.url}/`} />
        <link rel="alternate" hrefLang="es-ES" href={`${SITE.url}/`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE.url}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Vibra Marketing" />
        <meta property="og:title" content={HOME_TITLE} />
        <meta property="og:description" content={HOME_DESCRIPTION} />
        <meta property="og:url" content={`${SITE.url}/`} />
        <meta property="og:image" content={SITE.ogImage} />
        <meta property="og:locale" content="es_ES" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={HOME_TITLE} />
        <meta name="twitter:description" content={HOME_DESCRIPTION} />
        <meta name="twitter:image" content={SITE.ogImage} />
        <script type="application/ld+json">{JSON.stringify(PRICING_ITEMLIST_SCHEMA)}</script>
      </Helmet>

      <Header />

      <main>
        <Hero />
        <Suspense fallback={null}>
          <div data-reveal-deep><ServiceSelector /></div>
          <div data-reveal-deep><PricingSection /></div>
          <div data-reveal-deep><TrustpilotBar /></div>
          <div data-reveal-deep><TeamSection /></div>
          <div data-reveal-deep><ClientsSection variant="full" /></div>
          <div data-reveal-deep><ReviewsSection /></div>
          <div data-reveal-deep><ContactSection /></div>
        </Suspense>
      </main>

      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
